/**
 * @file ShowRequestExplanationModal
 */
'use strict'

/**
 * @classname ShowRequestExplanationModal
 * @classdesc 求人説明のモーダルを表示する
 */
export default class ShowRequestExplanationModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--request-explanation
	 */
	constructor($e) {
		console.log('ShowRequestExplanationModal.constructor')
		this._$e = $e
		this._$modal = $e.closest('.modal')
		const $html = $('html')
		if ($html.hasClass('iphone') || $html.hasClass('android')) {
			this._$target = $('#modal--job-entry-sp')
		} else {
			this._$target = $('#modal--job-entry-pc')
		}
		console.log(this._$target)
		$e.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof ShowRequestExplanationModal
	 * @return {undefined}
	 */
	onClick() {
		console.log('ShowRequestExplanationModal.onClick')
		this._$modal.hide('hide');
		this._$target.fadeToggle('swing')
	}

}
